var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:_vm.videoRef,staticClass:"w-100",class:_vm.videoClass,attrs:{"disablePictureInPicture":_vm.disablePictureInPicture,"autoplay":_vm.autoPlay,"poster":_vm.poster,"src":_vm.src,"controls":"","controlsList":"nodownload"},on:{"progress":_vm.progress,"canplay":_vm.canPlay,"ended":function($event){return _vm.ended()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }